module.exports = __webpack_public_path__ + "static/img/ic_drugstore_on@2x.38e0af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_drugstore_on@2x.png
// module id = V2m2
// module chunks = 1